module.exports = __webpack_public_path__ + "img/scatter-plot-dark-01.26ec6dea.jpg";